export enum EDetailsMode {
  Original = 'original',
  Chronological = 'chronological',
}
